import React from "react";
import classNames from "classnames";

import styles from "./LatencySlider.module.scss";

interface LatencySliderProps {
  options: number[];
  disabled?: boolean;
  selectedIndex: number;
  setSelectedIndex: (val: number) => void;
}

const LatencySlider = ({
  options,
  disabled,
  selectedIndex,
  setSelectedIndex,
}: LatencySliderProps) => {
  const getPercentage = () => (selectedIndex / (options.length - 1)) * 100;
  const getIndexPercentage = (i: number) => (i / (options.length - 1)) * 100;

  const handleBarClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const slider = e.currentTarget;
    const rect = slider.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const sliderWidth = rect.width;

    const percentage = clickX / sliderWidth;
    const newIndex = percentage * (options.length - 1);

    if (Math.abs(newIndex - selectedIndex) <= 0.15) {
      return;
    } else if (Math.round(newIndex) != selectedIndex) {
      setSelectedIndex(Math.round(newIndex));
      return;
    }

    setSelectedIndex(
      newIndex > selectedIndex ? Math.ceil(newIndex) : Math.floor(newIndex),
    );
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.bar}
        onClick={!disabled ? handleBarClick : () => null}
      />
      {options.map(
        (option, i) =>
          i >= selectedIndex && (
            <div
              key={option}
              className={styles.ghostThumb}
              style={{ left: `${getIndexPercentage(i)}%` }}
            />
          ),
      )}

      {options.map((option, i) => (
        <div
          key={option}
          className={classNames(
            styles.label,
            i === selectedIndex && styles.selected,
          )}
          style={{ left: `${getIndexPercentage(i)}%` }}
        >
          {option} ms
        </div>
      ))}

      <div
        className={styles.highlightBar}
        style={{ width: `${getPercentage()}%` }}
      />
      <div className={styles.thumb} style={{ left: `${getPercentage()}%` }} />
    </div>
  );
};

export default LatencySlider;
